// extracted by css-extract-rspack-plugin
export default {"cls1":"BackButton-cls1_uFj","cls2":"BackButton-cls2_SFU BackButton-cls1_uFj"};